module.exports = __webpack_public_path__ + "static/media/user-group-add.cbbcb65f.svg";